import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";
import { deleteEvent } from "../../../../../services/event.service";
import { ModalComponent } from "../../../../../ui-components/Modal";
import {
  adminButtonOutlinedSx,
  adminButtonPrimarySx,
} from "../../../../AdminDashboard/modalStyle";

export default function DeleteButton({
  id,
  updateEvents,
}: {
  id: number;
  updateEvents: Function;
}) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleDelete = () => {
    deleteEvent(id)
      .then(() => {
        updateEvents();
        handleClose();
      })
      .catch(() => {
        handleClose();
      });
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Apagar Evento"
        autoHeight
      >
        <Box sx={{ py: 2 }}>
          <Typography variant="body1">
            Você realmente deseja apagar este evento? Essa ação pode ser
            irreversível e afetar outros dados!
          </Typography>
        </Box>
        <Box
          sx={{
            p: 3,
            borderTop: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={adminButtonOutlinedSx}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleDelete}
            variant="contained"
            sx={adminButtonPrimarySx}
          >
            Apagar
          </Button>
        </Box>
      </ModalComponent>
      <IconButton title="Pressione 2 vezes para apagar" onClick={handleOpen}>
        <DeleteIcon />
      </IconButton>
    </>
  );
}
